// WP-1.20 (S-46 About): deployment identity + the persisted error log.
import {
  errorLogResponseSchema,
  metaResponseSchema,
  rebuildProjectionsResponseSchema,
  type ErrorLogEntry,
  type MetaResponse,
  type RebuildProjectionsResponse,
} from '@pfos/shared';
import {
  useMutation,
  useQuery,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import { api } from './api';

export function useMeta(): UseQueryResult<MetaResponse> {
  return useQuery({
    queryKey: ['meta'],
    queryFn: async () => metaResponseSchema.parse(await api.get('/api/v1/meta')),
  });
}

export function useErrors(): UseQueryResult<ErrorLogEntry[]> {
  return useQuery({
    queryKey: ['errors'],
    queryFn: async () => errorLogResponseSchema.parse(await api.get('/api/v1/errors')).errors,
  });
}

/** BK-2 export-everything is served auth-gated and same-origin, so a plain download link
 * carries the session cookie — no JS blob handling needed. */
export const EXPORT_EVERYTHING_URL = '/api/v1/export/everything';

/** WP-5.5 (OB-3/LG-4 "maintenance actions"): a full replay-vs-live integrity check. */
export function useRebuildProjections(): UseMutationResult<
  RebuildProjectionsResponse,
  Error,
  void
> {
  return useMutation({
    mutationFn: async () =>
      rebuildProjectionsResponseSchema.parse(await api.post('/api/v1/system/rebuild-projections')),
  });
}
